import React, { useState } from "react";
import Box from "@mui/material/Box";
import FilterComponent from "../../../../ReusableFIlterComponent/FilterComponent";
import store from "../../../../../store";
import { useSelector } from "react-redux";
import {
  setSelectedEntityType,
  setTrafficSourceFilter,
} from "../../../../../features/metaEntitiesSlice";

const TrafficClickIdentifierFilter = () => {
  const [searchSource, setSearchSource] = useState("");
  const { metaEntityList, trafficSourceFilter } = useSelector(
    (state: any) => state?.metaEntity
  );

  const filterConfig = [
    {
      key: "Traffic Source",
      label: "Select Traffic Source",
      searchTerm: searchSource,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchSource(e.target.value),
      selectedOption: trafficSourceFilter,
      filterName: "traffic_source",
      data: metaEntityList,
      onSelectionChange: (updatedSelection: any) =>
        store.dispatch(setTrafficSourceFilter(updatedSelection)),
      count: trafficSourceFilter && trafficSourceFilter.length,
      colorSelected:
        trafficSourceFilter !== null && trafficSourceFilter?.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  const clearFilters = () => {
    store.dispatch(setSelectedEntityType(""));
    store.dispatch(setTrafficSourceFilter(null));
    setSearchSource("");
  };

  return (
    <Box data-tracker="233">
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
};

export default TrafficClickIdentifierFilter;
